export { default } from './HeroCollection';
